/**
 * Asset bill type, auto-generated using table from funding asset bill details:
 * https://www.okx.com/docs-v5/en/#rest-api-funding-asset-bills-details
 */
export enum ASSET_BILL_TYPE {
  DEPOSIT = '1',
  WITHDRAWAL = '2',
  CANCELED_WITHDRAWAL = '13',
  TRANSFER_TO_SUB_ACCOUNT = '20',
  TRANSFER_FROM_SUB_ACCOUNT = '21',
  CLAIM = '28',
  SYSTEM_REVERSAL = '47',
  RECEIVED_FROM_ACTIVITIES = '48',
  GIVEN_AWAY_TO_ACTIVITIES = '49',
  RECEIVED_FROM_APPOINTMENTS = '50',
  DEDUCTED_FROM_APPOINTMENTS = '51',
  RED_PACKET_SENT = '52',
  RED_PACKET_SNATCHED = '53',
  RED_PACKET_REFUNDED = '54',
  CONVERSION = '61',
  CLAIM_REBATE_CARD = '68',
  DISTRIBUTE_REBATE_CARD = '69',
  TOKEN_RECEIVED = '72',
  TOKEN_GIVEN_AWAY = '73',
  TOKEN_REFUNDED = '74',
  SUBSCRIPTION_TO_SAVINGS = '75',
  REDEMPTION_TO_SAVINGS = '76',
  DISTRIBUTE = '77',
  LOCK_UP = '78',
  NODE_VOTING = '79',
  STAKING_1 = '80',
  VOTE_REDEMPTION = '81',
  STAKING_REDEMPTION_1 = '82',
  STAKING_YIELD = '83',
  VIOLATION_FEE = '84',
  POW_MINING_YIELD = '85',
  CLOUD_MINING_PAY = '86',
  CLOUD_MINING_YIELD = '87',
  SUBSIDY = '88',
  STAKING_2 = '89',
  STAKING_SUBSCRIPTION = '90',
  STAKING_REDEMPTION_2 = '91',
  ADD_COLLATERAL = '92',
  REDEEM_COLLATERAL = '93',
  INVESTMENT = '94',
  BORROWER_BORROWS = '95',
  PRINCIPAL_TRANSFERRED_IN = '96',
  BORROWER_TRANSFERRED_LOAN_OUT = '97',
  BORROWER_TRANSFERRED_INTEREST_OUT = '98',
  INVESTOR_TRANSFERRED_INTEREST_IN = '99',
  PREPAYMENT_PENALTY_TRANSFERRED_IN = '102',
  PREPAYMENT_PENALTY_TRANSFERRED_OUT = '103',
  FEE_TRANSFERRED_IN = '104',
  FEE_TRANSFERRED_OUT = '105',
  OVERDUE_FEE_TRANSFERRED_IN = '106',
  OVERDUE_FEE_TRANSFERRED_OUT = '107',
  OVERDUE_INTEREST_TRANSFERRED_OUT = '108',
  OVERDUE_INTEREST_TRANSFERRED_IN = '109',
  COLLATERAL_FOR_CLOSED_POSITION_TRANSFERRED_IN = '110',
  COLLATERAL_FOR_CLOSED_POSITION_TRANSFERRED_OUT = '111',
  COLLATERAL_FOR_LIQUIDATION_TRANSFERRED_IN = '112',
  COLLATERAL_FOR_LIQUIDATION_TRANSFERRED_OUT = '113',
  INSURANCE_FUND_TRANSFERRED_IN = '114',
  INSURANCE_FUND_TRANSFERRED_OUT_ = '115',
  PLACE_AN_ORDER = '116',
  FULFILL_AN_ORDER = '117',
  CANCEL_AN_ORDER = '118',
  MERCHANTS_UNLOCK_DEPOSIT = '119',
  MERCHANTS_ADD_DEPOSIT = '120',
  FIATGATEWAY_PLACE_AN_ORDER = '121',
  FIATGATEWAY_CANCEL_AN_ORDER = '122',
  FIATGATEWAY_FULFILL_AN_ORDER = '123',
  JUMPSTART_UNLOCKING = '124',
  MANUAL_DEPOSIT = '125',
  INTEREST_DEPOSIT = '126',
  INVESTMENT_FEE_TRANSFERRED_IN = '127',
  INVESTMENT_FEE_TRANSFERRED_OUT = '128',
  REWARDS_TRANSFERRED_IN = '129',
  TRANSFERRED_FROM_TRADING_ACCOUNT = '130',
  TRANSFERRED_TO_TRADING_ACCOUNT = '131',
  FROZEN_BY_CUSTOMER_SERVICE = '132',
  UNFROZEN_BY_CUSTOMER_SERVICE = '133',
  TRANSFERRED_BY_CUSTOMER_SERVICE = '134',
  CROSS_CHAIN_EXCHANGE = '135',
  CONVERT = '136',
  ETH_2_0_SUBSCRIPTION = '137',
  ETH_2_0_SWAPPING = '138',
  ETH_2_0_EARNINGS = '139',
  FEE_TRANSFER_IN = '141',
  FEE_TRANSFER_OUT = '142',
  SYSTEM_REVERSE = '143',
  TRANSFER_OUT_OF_UNIFIED_ACCOUNT_RESERVE = '144',
  REWARD_EXPIRED = '145',
  CUSTOMER_FEEDBACK = '146',
  VESTED_SUSHI_REWARDS = '147',
  AFFILIATE_COMMISSION = '150',
  REFERRAL_REWARD = '151',
  BROKER_REWARD = '152',
  JOINER_REWARD = '153',
  MYSTERY_BOX_REWARD = '154',
  REWARDS_WITHDRAW = '155',
  FEE_REBATE_1 = '156',
  COLLECTED_CRYPTO = '157',
  DUAL_INVESTMENT_SUBSCRIBE = '160',
  DUAL_INVESTMENT_COLLECTION = '161',
  DUAL_INVESTMENT_PROFIT = '162',
  DUAL_INVESTMENT_REFUND = '163',
  NEW_YEAR_REWARDS_2022 = '169',
  REFERRAL_REFERRED_CUSTOMER = '170',
  REFERRAL_WAS_REFERRED = '171',
  SUB_AFFILIATE_COMMISSION = '172',
  FEE_REBATE_2 = '173',
  PAY = '174',
  LOCKED_COLLATERAL = '175',
  LOAN = '176',
  ADDED_COLLATERAL = '177',
  RETURNED_COLLATERAL = '178',
  REPAYMENT = '179',
  UNLOCKED_COLLATERAL = '180',
  REPAY_AIRDROPPED_CRYPTO = '181',
  FEEDBACK_BOUNTY = '182',
  INVITE_FRIENDS_REWARDS = '183',
  DIVIDE_THE_REWARD_POOL = '184',
  BROKER_CONVERT_REWARD = '185',
  FREEETH = '186',
  CONVERT_TRANSFER = '187',
  SLOT_AUCTION_CONVERSION = '188',
  MYSTERY_BOX_BONUS = '189',
  CARD_PAYMENT_BUY_1 = '193',
  CARD_PAYMENT_BUY_2 = '194',
  UNTRADABLE_ASSET_WITHDRAWAL = '195',
  UNTRADABLE_ASSET_WITHDRAWAL_REVOKED = '196',
  UNTRADABLE_ASSET_DEPOSIT = '197',
  UNTRADABLE_ASSET_COLLECTION_1 = '198',
  UNTRADABLE_ASSET_COLLECTION_2 = '199',
  BUY = '200',
  WIN_CRYPTO_WITH_SATOSHI = '211',
}

export type AssetBillType = `${ASSET_BILL_TYPE}`;
